import { request } from './request';

export const geminiChatRequest = (messages, metadataFilter, model) => {
  const body = { messages };
  if (metadataFilter) {
    body.metadataFilter = metadataFilter;
  }
  if (model) {
    body.model = model;
  }
  return request('/gemini/chat', 'POST', body);
};
